import { render, staticRenderFns } from "./HrText.vue?vue&type=template&id=028fccb4&scoped=true&lang=pug"
import script from "./HrText.vue?vue&type=script&lang=ts"
export * from "./HrText.vue?vue&type=script&lang=ts"
import style0 from "./HrText.vue?vue&type=style&index=0&id=028fccb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028fccb4",
  null
  
)

export default component.exports